module.exports = __webpack_public_path__ + "static/media/IMG-8.c9468fcf.jpg";